"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEmptyIndex = createEmptyIndex;
exports.resolveId = resolveId;
function createEmptyIndex() {
    return {
        documents: new Map(),
        byId: new Map(),
        bySlug: new Map(),
        backlinks: new Map(),
        children: new Map(),
        parent: new Map(),
        stepBlockers: new Map(),
    };
}
/**
 * Resolves a doc reference that may be either a ULID id or a slug (refs only).
 * Returns the canonical id, or null if not found.
 */
function resolveId(index, idOrSlug) {
    if (index.byId.has(idOrSlug))
        return idOrSlug;
    const viaSlug = index.bySlug.get(idOrSlug);
    if (viaSlug)
        return viaSlug;
    // Fall back to the legacy documents map for semantic ids not yet migrated.
    if (index.documents.has(idOrSlug))
        return idOrSlug;
    return null;
}
